"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP);
const partners = [{
  name: "MIAMI LUXE"
}, {
  name: "BRICKELL AUTO"
}, {
  name: "CORAL GABLES"
}, {
  name: "VALERO ELITE"
}, {
  name: "PREMIUM DETAILING"
}, {
  name: "MIAMI SHINE"
}];
export default function Partners() {
  const container = useRef<HTMLDivElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const track = trackRef.current;
    if (!track) return;
    const mm = gsap.matchMedia();
    mm.add({
      motionOk: "(prefers-reduced-motion: no-preference) and (min-width: 768px)"
    }, context => {
      const conditions = context.conditions as {
        motionOk: boolean;
      } | undefined;
      if (!conditions?.motionOk) return;
      const halfWidth = track.scrollWidth / 2;
      const tween = gsap.to(track, {
        x: -halfWidth,
        duration: 90,
        ease: "none",
        repeat: -1
      });
      const onEnter = () => tween.pause();
      const onLeave = () => tween.resume();
      track.addEventListener("mouseenter", onEnter);
      track.addEventListener("mouseleave", onLeave);
      return () => {
        track.removeEventListener("mouseenter", onEnter);
        track.removeEventListener("mouseleave", onLeave);
      };
    });
  }, {
    scope: container
  });
  const marqueeLogos = [...partners, ...partners];
  return <section data-section-id="28715" id="follow-our-work-siga-nuestro-trabajo" className="bg-background text-foreground relative overflow-hidden py-16 md:py-20">
      <div ref={container} className="mx-auto w-full max-w-[1360px] px-[clamp(1.25rem,5vw,4rem)]">
        <div className="flex flex-col items-center">
          <p className="font-default text-xs uppercase" style={{
          color: "var(--muted-foreground)",
          letterSpacing: "0.22em"
        }}>
            Trusted Partners
          </p>

          <div className="mt-12 w-full overflow-hidden" aria-label="Trusted luxury partners">
            {}
            <div ref={trackRef} className="hidden md:flex w-max items-center gap-x-24" style={{
            willChange: "transform"
          }}>
              {marqueeLogos.map((partner, i) => <div key={`${partner.name}-${i}`} data-index={i} className="shrink-0 opacity-45 hover:opacity-90 transition-opacity duration-500 ease-out">
                  <PartnerMark name={partner.name} />
                </div>)}
            </div>

            {}
            <div className="md:hidden grid grid-cols-3 gap-x-6 gap-y-8 items-center justify-items-center">
              {partners.map((partner, i) => <div key={partner.name} data-index={i} className="opacity-55">
                  <PartnerMark name={partner.name} compact />
                </div>)}
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20 w-full h-px" style={{
        backgroundColor: "hsla(38, 20%, 90%, 0.09)"
      }} />
      </div>
    </section>;
}
function PartnerMark({
  name,
  compact = false
}: {
  name: string;
  compact?: boolean;
}) {
  const height = compact ? 18 : 28;
  return <div className="flex items-center justify-center" style={{
    height: `${height}px`
  }}>
      <span className="font-serif whitespace-nowrap" style={{
      color: "hsl(38, 18%, 78%)",
      fontSize: compact ? "0.75rem" : "0.95rem",
      letterSpacing: "0.32em",
      fontWeight: 400,
      lineHeight: 1
    }}>
        {name}
      </span>
    </div>;
}